import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/api/client';
import { queryKeys } from '@/api/keys';
import { commissioningProgressSchema } from '@/api/schemas/devices';

/**
 * Commissioning progress. The footer's `362 / 362 commissioned` and the
 * dashboard tile read the same query, so the two cannot disagree.
 */
export function useCommissioningProgress(enabled = true) {
  return useQuery({
    queryKey: queryKeys.devices.commissioningProgress(),
    queryFn: async () => commissioningProgressSchema.parse(await apiGet('/commissioning/progress')),
    enabled,
    staleTime: 30_000,
  });
}
